export const faqsFilter = () => {
    

    function handleCategoryClick(event) {
        var selectedTermId = event.currentTarget.getAttribute('data-term-id');
        
        // Remove active class from all categories and add it to the clicked one
        document.querySelectorAll('.faq-category').forEach(function(category) {
            category.classList.remove('active');
        });
        event.currentTarget.classList.add('active');

        // Show/Hide FAQs based on selected category
        var faqs = document.querySelectorAll('.faqs__list--large li');
        if (selectedTermId === 'all') {
            // Show all FAQs if "View All" is clicked
            faqs.forEach(function(faq) {
                faq.style.display = '';
            });
        } else {
            // Filter FAQs based on selected category
            faqs.forEach(function(faq) {
                console.log('here');
                var categoryIds = faq.getAttribute('data-category-ids').toString().split(' ');
                if (categoryIds.includes(selectedTermId.toString())) {
                    faq.style.display = '';
                } else {
                    faq.style.display = 'none';
                }
            });
        }
    }

    // Attach click event listeners to all category elements
    document.querySelectorAll('.faq-category').forEach(function(category) {
        category.addEventListener('click', handleCategoryClick);
    });

    // Trigger click on the "View All" option initially to show all FAQs
    // const viewAllElement = document.querySelector('.faq-category[data-term-id="all"]');
    // if (viewAllElement) {
    //     viewAllElement.click();
    // }


    function toggleFaqCategories() {
        const toggleElement = document.querySelector('.js-toggle-faq-categories');
        const ulElement = toggleElement.nextElementSibling;
        const screenWidth = window.innerWidth;

        if (screenWidth > 768) {
            ulElement.style.display = 'block';
        } else {
            ulElement.style.display = 'none';
        }
    }

    const toggleElement = document.querySelector('.js-toggle-faq-categories');
    if (toggleElement) {
        toggleElement.addEventListener('click', function() {
            const ul = this.nextElementSibling;
            ul.style.display = (ul.style.display === 'none' || ul.style.display === '') ? 'block' : 'none';
        });

        window.addEventListener('resize', toggleFaqCategories);

        toggleFaqCategories();
    }
}